import { Component, OnDestroy, OnInit } from '@angular/core';
import { IClientAcount } from '../interface/dto';
import { EventService } from '../services/event-services/error-event.service';
import { AuthService } from '../services/http-services/authservice.service';
import { SnackbarService } from '../services/snackbar.service';
import { environment as env } from 'src/environments/environment';
import { OnboardingStatus } from '../models/login';

@Component( {
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: [ './user-registration.component.scss' ]
} )
export class UserRegistrationComponent implements OnInit, OnDestroy {

  clienAccount: IClientAcount = {
    companyID: '',
    companyName: '',
    companyEmail: '',
    companyPhoneNo: '',
    companyCertificate: undefined,
    extension: '',
    companyRegistrationNo: '',
    contactPersonName: '',
    contactPersonEmail: '',
    contactPersonPhoneNo: '',
    companyWebsite: '',
    CompanyCertificateByte: undefined,
    password: ''
  };
  showForm = false;
  showCode = false;
  showSignUp = true;
  codeText = '';
  confirmPassword = '';
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
  errorSubscription: any;
  constructor ( private snackBar: SnackbarService, private authService: AuthService, private errorEvent: EventService ) { }

  ngOnInit () {
    this.errorSubscription = this.errorEvent.httpErrorMessageEvent.subscribe( message => {
      if ( message ) {
        let i = this.errorEvent.getErrID();
        if ( message.includes( i ) ) {
          message = message.replace( i, '' );
          this.snackBar.error( message );
          this.errorEvent.setErrID( null );
        }
      }
    } );

    const cd = JSON.parse( this.authService.getCookie( env.clientInformationStore ) );
    if ( cd ) {
      this.clienAccount.companyEmail = cd.companyEmail ?? "";
      this.clienAccount.companyName = cd.companyName ?? "";
      this.clienAccount.password = cd.password ?? "";
      this.confirmPassword = this.clienAccount.password;
      if ( cd.status === OnboardingStatus.AwaitingEmailVerification ) {
        this.blankPage();
        this.showCode = true;
      }
      else if ( cd.status === OnboardingStatus.AwaitingProfileCompletion ) {
        this.blankPage();
        this.showForm = true;
      }
    }
  }

  onFileChange ( event: any ) {
    if ( event.target.files && event.target.files[ 0 ] ) {
      this.clienAccount.companyCertificate = event.target.files[ 0 ];
    }
  }

  async updateClient () {
    ;
    if ( this.modelCheck() ) {
      this.clienAccount.extension = this.clienAccount.companyCertificate.name.split( '.' ).pop();
      let formData = new FormData();
      formData.append( 'companyName', '' + this.clienAccount.companyName );
      formData.append( 'companyEmail', '' + this.clienAccount.companyEmail );
      formData.append( 'companyPhoneNo', '' + this.clienAccount.companyPhoneNo );
      formData.append( 'companyCertificate', this.clienAccount.companyCertificate );
      formData.append( 'extension', '' + this.clienAccount.extension );
      formData.append( 'companyRegistrationNo', '' + this.clienAccount.companyRegistrationNo );
      formData.append( 'contactPersonName', '' + this.clienAccount.contactPersonName );
      formData.append( 'contactPersonEmail', '' + this.clienAccount.contactPersonEmail );
      formData.append( 'contactPersonPhoneNo', '' + this.clienAccount.contactPersonPhoneNo );
      formData.append( 'companyWebsite', '' + this.clienAccount.companyWebsite );

      const res = await this.authService.updateClient( formData );
      this.snackBar.success( "Account updated successfully." );
      window.location.assign( '/login' );
    }

  }

  blankPage () {
    this.showCode = false;
    this.showSignUp = false;
    this.showForm = false;
  }

  modelCheck () {

    if ( this.clienAccount.companyPhoneNo === ( null || undefined || "" ) ) {
      this.snackBar.error( "Please Fill Company Phone No." );
      return false;
    }
    if ( this.clienAccount.companyRegistrationNo === ( null || undefined || "" ) ) {
      this.snackBar.error( "Please Fill Company Registration No." );
      return false;
    }
    if ( this.clienAccount.contactPersonName === ( null || undefined || "" ) ) {
      this.snackBar.error( "Please Fill Contact Person Name" );
      return false;
    }
    if ( this.clienAccount.contactPersonPhoneNo === ( null || undefined || "" ) ) {
      this.snackBar.error( "Please Fill Contact Person Phone No." );
      return false;
    }
    if ( this.clienAccount.contactPersonEmail === ( null || undefined || "" ) ) {
      this.snackBar.error( "Please Fill Contact Person Email" );
      return false;
    }
    if ( this.clienAccount.companyCertificate === ( null || undefined ) ) {
      this.snackBar.error( "Please upload a company certificate" );
      return false;
    }
    // if (this.clienAccount.companyWebsite === (null || undefined || "")) {
    //   this.snackBar.error("Please Fill Company Website");
    //   return false;
    // }

    return true;
  }

  async saveClient () {
    ;
    if ( this.clienAccount.companyName === ( null || undefined || "" ) ) {
      this.snackBar.error( "Please Fill Company Name" );
      return false;
    }
    if ( this.clienAccount.companyEmail === ( null || undefined || "" ) ) {
      this.snackBar.error( "Please Fill Company Email" );
      return false;
    }
    if ( this.clienAccount.password === ( null || undefined || "" ) ) {
      this.snackBar.error( "Please Fill password" );
      return false;
    }
    if ( this.clienAccount.password !== this.confirmPassword ) {
      this.snackBar.error( "Passwords do not match" );
      return false;
    }
    var regx = new RegExp( this.emailPattern );
    if ( !regx.test( this.clienAccount.companyEmail ) ) {
      this.snackBar.error( "Invalid Email Format" );
      return false;
    }
    const data = { "companyName": this.clienAccount.companyName, "companyEmail": this.clienAccount.companyEmail, "password": this.clienAccount.password };
    const res = await this.authService.saveClient( data );
    this.blankPage();
    this.showCode = true;
    this.snackBar.success( "Verify Code Sent. Please Check your email address and SPAM." );
  }

  async sendCode () {
    try {
      const res = await this.authService.sendCode( this.clienAccount );
      this.snackBar.success( "Verification Code Sent to your Email" );
    }
    catch ( err ) {

    }
  }

  async verifyEmail () {
    try {
      let cAccount = {"companyEmail":this.clienAccount.companyEmail,"companyName":this.clienAccount.companyName,"code":this.codeText}
      await this.authService.verifyEmail( cAccount );
      this.snackBar.success( "Verified" );
      const cd = JSON.parse( this.authService.getCookie( env.clientInformationStore ) );
      cd.status = OnboardingStatus.AwaitingProfileCompletion;
      this.authService.setCookie( env.clientInformationStore, JSON.stringify( cd ) );
      this.blankPage();
      this.showForm = true;
    }
    catch ( err ) {
      this.snackBar.warning(err );
    }

    //let cd = JSON.parse( this.authService.getCookie( env.clientInformationStore ) );

    // this.authService.createClient( cd ).then( ( e: any ) => {
    //   this.snackBar.success( "Verified" );
    //   this.blankPage();
    //   this.showForm = true;
    //   cd.code = null;
    //   this.authService.setCookie( env.clientInformationStore, JSON.stringify( cd ) );
    //}
    // if ( cd.code.toLocaleLowerCase() == this.codeText.toLocaleLowerCase() ) {

    //    );
    // } else {
    //   this.snackBar.warning( "Code Mismatch" );
    //   return;
    // }

  }
  ngOnDestroy() {
    if (this.errorSubscription) {
      this.errorSubscription.unsubscribe();
    }
  }
}
